import { render } from "./BreakdownCard.vue?vue&type=template&id=8e097b98"
import script from "./BreakdownCard.vue?vue&type=script&lang=js"
export * from "./BreakdownCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__